import React, { useRef, useState, useEffect } from "react";
import * as XLSX from "xlsx";
import axiosInstance from "../../server/axios";
import { Button } from "@mui/material";

import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

const DataInput = () => {
  const MAX_FILES = 3;

  const [dateInfo,setDateInfo] = useState('');
  const [userInfo,setUserInfo] = useState('');
  const [loading, setLoading] = useState(false);
  const [excelFiles, setExcelFiles] = useState([]);
  // excelFiles 구조[{ fileName: string, data: [] }]

  const dropRef = useRef(null);

  const readExcelFile = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const wb = XLSX.read(binaryStr, { type: "binary" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const sheetData = XLSX.utils.sheet_to_json(ws);
        resolve({
          fileName: file.name,
          data: sheetData,
        });
      };
      reader.readAsBinaryString(file);
    });
  };

  const handleFiles = async (files) => {
    const fileArray = Array.from(files)
      .filter(file =>
        file.name.endsWith(".xls") ||
        file.name.endsWith(".xlsx") ||
        file.name.endsWith(".csv")
      )
      .slice(0, MAX_FILES - excelFiles.length);

    const parsedFiles = await Promise.all(
      fileArray.map(file => readExcelFile(file))
    );

    setExcelFiles(prev => [...prev, ...parsedFiles].slice(0, MAX_FILES));
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleChange = (e) => {
    handleFiles(e.target.files);
    e.target.value = "";
  };

  const deleteFile = (index) => {
    setExcelFiles(prev => prev.filter((_, i) => i !== index));
  };

  useEffect( () => {
    const getUpdate = async () => {
      const updateINFO =  await axiosInstance.get(`/orderboard/checkupdate`);
      setDateInfo(updateINFO.data[0].updated);
      setUserInfo(updateINFO.data[0].user);
     }
     getUpdate();
    const dropBox = dropRef.current;
    if (!dropBox) return;
    const prevent = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    dropBox.addEventListener("dragenter", prevent);
    dropBox.addEventListener("dragover", prevent);
    dropBox.addEventListener("drop", handleDrop);

    return () => {
      dropBox.removeEventListener("dragenter", prevent);
      dropBox.removeEventListener("dragover", prevent);
      dropBox.removeEventListener("drop", handleDrop);
    };

  }, [excelFiles]);

  const sendExcelFiles = async() => {
    setLoading(true); // 시작
    try {
      const checkList = ['구매일(월)보','판매일(월)보','재고조정현황'];
      const fileNameArr = Array.from({length:excelFiles.length}, (value,index) => excelFiles[index].fileName).sort((a, b) => {
        const getIndex = (file) => {
          const idx = checkList.findIndex(keyword => file.includes(keyword));
          return idx === -1 ? Infinity : idx;
        };
        return getIndex(a) - getIndex(b);
      });

      const checkFileName = (_fileNameArr,_CheckListArr) => {
        for(let i = 0; i < _fileNameArr.length; i++){
          for(let j = 0; j <_CheckListArr.length; j++){
            if(_fileNameArr[i].toLowerCase().includes(_CheckListArr[j].toLowerCase())){
              _CheckListArr.splice(j,1);
              break;
            }
            if(j ===_CheckListArr.length-1){
              alert(`잘못된 파일 또는 중복 업로드 됐습니다 ${_fileNameArr[i]}`);            
              return false
            }
          }
          if(i === _fileNameArr.length-1){
            if(!_CheckListArr.includes('구매일(월)보') && !_CheckListArr.includes('판매일(월)보')){
              return true;
            }else{
              alert(`최소 [구매(월)보] [판매(월)보] 2가지 엑셀 파일을 올려주세요`)
              return false;
            }
          }
        }
      }

      const makeServerData = (_excelFiles) => {
        const excelType = [];
        const excelArr = [];
        for(let i = 0; i < _excelFiles.length; i++){
          if(_excelFiles[i].fileName.toLowerCase().includes('구매일(월)보'.toLowerCase())){
            excelType.push('buy');
            excelArr.push(_excelFiles[i].data);
            continue;
          }
          if(_excelFiles[i].fileName.toLowerCase().includes('판매일(월)보'.toLowerCase())){
            excelType.push('sell');
            excelArr.push(_excelFiles[i].data);
            continue;
          }
          if(_excelFiles[i].fileName.toLowerCase().includes('재고조정현황'.toLowerCase())){
            excelType.push('etc');
            excelArr.push(_excelFiles[i].data);
            continue;
          }
        }
        return [excelType,excelArr];
      }

      const CheckingFile = checkFileName(fileNameArr,[...checkList]);

      if(CheckingFile === true){
        const datafile = makeServerData(excelFiles);
        const sendData = await axiosInstance.post(`/orderboard/sendexcel`,{
          type: datafile[0],
          data: datafile[1]
        })

        if(sendData.data === 'ok'){
          alert('updated!');
          setExcelFiles([]);
        }
      }

    } catch (error) {
      console.error(error);
      alert('업로드 중 오류 발생');
    } finally {
      setLoading(false); // 종료 (무조건 실행)
    }
  }





  return (
    <div>
     {loading && (
      <div style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.4)", // 암전 효과
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999
      }}>
        <Stack alignItems="center" spacing={2}>
          <CircularProgress size={80} />
          <div style={{ color: "white" }}>업로드 중...</div>
        </Stack>
      </div>
      )}
      <div><h2>구매, 판매 데이터 업데이트</h2></div>
      <div>최근 업데이트 일자 : {dateInfo} {userInfo}</div>
      <div
        ref={dropRef}
        style={{
          margin:"50px",
          border: "3px dashed #999",
          padding: "50px",
          textAlign: "center",
          marginBottom: "10px",
        }}
      >
      엑셀 파일을 드래그 앤 드롭하세요 (최대 3개 [필수:구매,판매],[선택:조정])
      {excelFiles.length > 0 ? 
      <div>
      <ul style={{ marginTop: "15px",border:'1px solid red'}}>
      {excelFiles.map((file, idx) => (
        <li key={idx} style={{ marginBottom: "8px" }}>
          {file.fileName} ({file.data.length} rows)
          <button
            onClick={() => deleteFile(idx)}
            style={{
              marginLeft: "10px",
              color: "white",
              background: "red",
              border: "none",
              cursor: "pointer",
            }}
          >
            삭제
          </button>
        </li>
      ))}
      </ul>
      <Button 
        variant="outlined" 
        color="primary"
        onClick={()=>sendExcelFiles()}
      >
        엑셀 파일 {excelFiles.length} 개 전송
      </Button>
      </div>
      :
      <></>
      }
      </div>
    </div>
  );
};
export default DataInput;